import React, { useState, useEffect } from "react";
import * as theme from '../../../theme';
import Heading from "../../../components/Heading";
import VideoPlayer from "../../../components/VideoPlayer";
import ConfirmationModal from '../../../components/ConfirmationModal';
import FocusScansList from '../../../components/FocusScansList';
import MiniScansList from '../../../components/MiniScansList';
import Button from "@mui/material/Button";
import { Info } from '@mui/icons-material';

function SchedulingClients({ title }) {
  const [focusModalOpen, setFocusModalOpen] = useState(false);
  const [miniModalOpen, setMiniModalOpen] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 800, position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
      <VideoPlayer videoId={title} isPublic={false} />
      <Heading
        title={title}
        subHeading={true}
        center={true}
      />
      <div style={{ ...theme.SubText, position: 'relative', marginTop: 0, marginBottom: 0, marginRight: 'auto', marginLeft: 'auto' }}>
        <strong>Focus Scan Requests</strong><br/> Focus Scans are additional scans that we perform in addition to the Root Cause, Supplement, and Emotion scans. You will receive a separate report for any Focus Scans selected.
      </div>
      <div style={{ fontSize: 14, display: 'flex', alignItems: 'center', marginTop: 8, justifyContent: 'flex-end' }}>
        <Button startIcon={<Info sx={{ fontSize: 16 }} />} onClick={() => setFocusModalOpen(true)}>
          View Focus Scan Options
        </Button>
      </div>
      <div style={{ ...theme.SubText, position: 'relative', marginTop: 20, marginBottom: 0, marginRight: 'auto', marginLeft: 'auto' }}>
        <strong>Mini Scan Requests</strong><br/> Mini Scans are included within the Root Cause scan and report. You will not receive a separate report for Mini Scans. Mini scans are not required. If any show up in the Root Cause scan, we will scan those regardless. This is just if you specifically want us to include this in the Root Cause scan.
      </div>
      <div style={{ fontSize: 14, display: 'flex', alignItems: 'center', marginTop: 8, justifyContent: 'flex-end' }}>
        <Button startIcon={<Info sx={{ fontSize: 16 }} />} onClick={() => setMiniModalOpen(true)}>
          View Mini Scan Options
        </Button>
      </div>
      <div style={{ ...theme.SubText, position: 'relative', marginTop: 20, marginRight: 'auto', marginLeft: 'auto' }}>
        <strong>Group Cohorts</strong><br/>For group cohorts, we can coordinate all scans to occur on the same day. To arrange this, please email us at <a href="mailto:hello@trubalancebioenergetics.com">hello@trubalancebioenergetics.com</a>. Note that all participants must mail their samples back in time for the scheduled scan. This option helps keep your cohort aligned and communication streamlined. We can also accommodate special scan dates outside our regular schedule for group bookings.
      </div>
      <ConfirmationModal
        open={focusModalOpen}
        onClose={() => setFocusModalOpen(false)}
        onConfirm={() => setFocusModalOpen(false)}
        title="Focus Scan Options"
        description="Below is a list of available focus scans and their descriptions."
        confirmButtonText="Close"
        hideCancelButton={true}
        children={<FocusScansList />}
      />
      <ConfirmationModal
        open={miniModalOpen}
        onClose={() => setMiniModalOpen(false)}
        onConfirm={() => setMiniModalOpen(false)}
        title="Mini Scan Options"
        description="Below is a list of available mini scans and their descriptions."
        confirmButtonText="Close"
        hideCancelButton={true}
        children={<MiniScansList />}
      />
    </div>
  );

}

export default SchedulingClients;